import { z } from "zod";
import { CommissionFieldsSchema } from "./Commission";
import { CompanySchema } from "./Company";
import { UserSchema } from "./User";

export const DocumentOfferQuestionFieldsSchema = z.object({
  id: z.number().int(),
  accountUser: z.any(),
  company: CompanySchema,
  companyName: z.string(),
  createdAt: z.string(),
  creatorUser: UserSchema,
  currencyCode: z.string(),
  currencyRatio: z.number(),
  defaultAddress: z.string(),
  deliveryType: z.any(),
  deliveryPlace: z.any(),
  documentHeader: z.string(),
  documentSeriesDefinition: z.any(),
  documentStatus: z.number().int(),
  documentSubtype: z.string(),
  exchange: z.any(),
  exchangeHistory: z.any(),
  exchangeRatio: z.number(),
  importId: z.string(),
  importCode: z.string(),
  importTyp: z.string(),
  manualStatusChanged: z.any(),
  modificationDate: z.string(),
  nip: z.string(),
  notes: z.string(),
  orderDeadline: z.string(),
  orderTime: z.string(),
  paymentType: z.any(),
  positions: z.any(),
  user: UserSchema,
  userPh: UserSchema,
  userPhName: z.string(),
  valueBrutto: z.number(),
  valueNetto: z.number(),
  valueNettoBeforeDiscount: z.number(),
});
export const PartialDocumentOfferQuestionFieldsSchema =
  DocumentOfferQuestionFieldsSchema.deepPartial();

export const DocumentOfferQuestionExtraFieldsSchema = z.object({
  attributes: z.array(z.any()), // TODO: define schema
  relations: z.object({
    documentInvoices: z.array(z.any()),
    documentStores: z.array(z.any()),
    documentOrders: z.array(z.any()),
    tasks: z.array(z.any()),
    documentOfferQuestions: z.array(z.any()),
    emailMessages: z.array(z.any()),
    communicationThreads: z.array(z.any()),
    odbcReports: z.array(z.any()),
    campaignOpportunities: z.array(z.any()),
    commissions: CommissionFieldsSchema,
  }),
  fullName: z.string(),
});
export const PartialDocumentOfferQuestionExtraFieldsSchema =
  DocumentOfferQuestionExtraFieldsSchema.deepPartial();

export const DocumentOfferQuestionSchema = z.intersection(
  DocumentOfferQuestionFieldsSchema,
  DocumentOfferQuestionExtraFieldsSchema
);

export type DocumentOfferQuestionFields = z.infer<
  typeof DocumentOfferQuestionFieldsSchema
>;
export type PartialDocumentOfferQuestionFields = z.infer<
  typeof PartialDocumentOfferQuestionFieldsSchema
>;
export type DocumentOfferQuestionExtraFields = z.infer<
  typeof DocumentOfferQuestionExtraFieldsSchema
>;
export type PartialDocumentOfferQuestionExtraFields = z.infer<
  typeof PartialDocumentOfferQuestionExtraFieldsSchema
>;
export type DocumentOfferQuestion = z.infer<typeof DocumentOfferQuestionSchema>;
